module.exports = __webpack_public_path__ + "img/bg7-1.744aad4e.png";